import { computed } from 'vue'
import { useStore } from 'vuex'

/**
 * Vue composable to load the remark tags from the Vuex store.
 * TODO: Remove once the remarkTags are converted into a Pinia store.
 * @returns An object containing the remark tags
 */
export default function useRemarkTags() {
  const store = useStore()

  const allRemarkTags = computed(
    () => store.state?.remarkTags?.allRemarkTags || []
  )

  return allRemarkTags
}
